import {once} from '@sail/utils';
import generateId from 'src/helpers/generateId';
import {MissingServiceObservabilityError} from 'src/internal/common/errors';
import logErrorInDev from 'src/internal/common/logErrorInDev';
import getMetricsTransport from 'src/internal/metrics/transport/getMetricsTransport';

import type {MetricParams} from 'src/internal/metrics/types';
import type {ObservabilityConfig} from 'src/types';

const logMissingServiceOnce = once(() => {
  logErrorInDev(new MissingServiceObservabilityError());
});

export default function record(
  config: ObservabilityConfig,
  metric: string,
  params?: MetricParams,
): void {
  const service = config.service;

  if (!service) {
    logMissingServiceOnce();

    return;
  }

  // Parameters required by the analytics event logger service
  const pageViewToken = config.pageViewToken;
  const meta = {
    client_id: service,
    event_id: generateId(),
    created: `${Math.floor(new Date().getTime() / 1000)}`,
    ...(pageViewToken ? {page_view_id: pageViewToken} : {}),
  };

  const transport = getMetricsTransport(service, {
    fetch: config.fetch,
    useAelMetricsEndpoint: config.metrics?.useAelMetricsEndpoint,
    useBatching: config.metrics?.useBatching,
    flushSignal: config.flushSignal,
  });

  transport.send({name: metric, params, meta});
}
